import { rivermeadowApi } from './api';

/**
 * CSV Migrations API endpoints
 */
export const csvMigrationsApi = rivermeadowApi.injectEndpoints({
    endpoints: (builder) => ({
        // Create CSV migration template
        createCsvMigrationTemplate: builder.mutation({
            query: (payload) => ({
                url: 'csvmigrations/template',
                method: 'POST',
                body: {
                    ...payload,
                    data_only_migration: false,
                    vdi_migration: false,
                    migration_type: 'full',
                    organization_id: sessionStorage.getItem('userOrg'),
                },
            }),
        }),

        // Get CSV migration template status
        getCsvMigrationTemplate: builder.query({
            query: (csvId) => ({
                url: `csvmigrations/template/${csvId}`,
                method: 'GET',
            }),
        }),

        // Download CSV migration template
        downloadCsvMigrationTemplate: builder.query({
            query: (csvId) => ({
                url: `csvmigrations/template/${csvId}`,
                method: 'GET',
                params: {
                    format: 'csv',
                    token: sessionStorage.getItem('sessionToken'),
                },
                responseHandler: 'text', // Important for CSV content
            }),
        }),

        // Validate CSV migrations
        validateCsvMigrations: builder.mutation({
            query: (payload) => {
                const orgId = sessionStorage.getItem('userOrg');
                return {
                    url: `csvmigrations/organizations/${orgId}/validate`,
                    method: 'POST',
                    body: {
                        ...payload,
                        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                    },
                }
            },
        }),

        // Upload/process CSV migrations
        uploadCsvMigrations: builder.mutation({
            query: (payload) => {
                const orgId = sessionStorage.getItem('userOrg');
                return {
                    url: `csvmigrations/organizations/${orgId}`,
                    method: 'POST',
                    body: {
                        ...payload,
                        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                    },
                }
            },
        }),
    }),
});

export const {
    useCreateCsvMigrationTemplateMutation,
    useGetCsvMigrationTemplateQuery,
    useLazyDownloadCsvMigrationTemplateQuery,
    useValidateCsvMigrationsMutation,
    useUploadCsvMigrationsMutation,
} = csvMigrationsApi;
